import { Outlet } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { useSelector } from "@legendapp/state/react";
import Sidebar from "@/layouts/AppLayout/Sidebar";
import { getDefaultOrganizationId } from "@/utils/organization";
import { fetchAgencies } from "@/stores/agenciesStore";
import { ThemeStore$ } from "@/stores/themeStore";
import MainContentRefContext from "@/contexts/MainContentRefContext";
import { TEXT } from "@/constants/text";
import styles from "@/layouts/AppLayout/AppLayout.module.css";

const AppLayout = () => {
  const mainRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    fetchAgencies(getDefaultOrganizationId());
  }, []);

  const darkMode = useSelector(() => ThemeStore$.darkMode.get());
  useEffect(() => {
    document.documentElement.dataset.theme = darkMode ? "dark" : "light";
  }, [darkMode]);

  return (
    <MainContentRefContext.Provider value={mainRef}>
      <div className={styles.shell}>
        <h1 className={styles.srOnly}>{TEXT.appLayout.heading}</h1>
        <Sidebar />
        <div ref={mainRef} className={styles.main}>
          <div className={styles.content}>
            <Outlet />
          </div>
        </div>
      </div>
    </MainContentRefContext.Provider>
  );
};

export default AppLayout;
